import { LlmResponseSectionTypename, PlainTextResponseSectionTypename } from '../types';
// Ably messages arrive either as raw JSON or wrapped in a CHIRP envelope
// (`{ chirpMessageJson: "..." }`). This unwraps both formats into a
// normalized CopilotMessage that the state machine can switch on.
export function parseCopilotMessage(message) {
  try {
    var _message$name;
    const raw = typeof message.data === 'string' ? JSON.parse(message.data) : message.data;
    const data = raw !== null && raw !== void 0 && raw.chirpMessageJson ? JSON.parse(raw.chirpMessageJson) : raw;
    return {
      name: (_message$name = message.name) !== null && _message$name !== void 0 ? _message$name : '',
      data
    };
  } catch (_unused) {
    return undefined;
  }
}
export function extractTextFromSections(sections) {
  let text = '';
  for (const section of sections) {
    if (section.__typename === LlmResponseSectionTypename || section.__typename === PlainTextResponseSectionTypename) {
      text += section.text;
    }
  }
  return text;
}